import React, { useEffect, useState } from "react";
import { api } from "../api";

const label = (a) => a.account_login == null
  ? `Compte inconnu (anciens trades) · ${a.trades} trades`
  : `N° ${a.account_login}${a.account_server || a.broker ? ` · ${a.account_server || a.broker}` : ""} · ${a.trades} trades`;

/** Sélecteur de compte MT5 ("" = tous les comptes). */
export const AnalyticsAccountSelect = ({ headers, value, onChange, testid }) => {
  const [accounts, setAccounts] = useState([]);
  useEffect(() => {
    api.get("/admin/analytics/accounts", headers).then(({ data }) => setAccounts(data.accounts || [])).catch(() => {});
  }, []); // eslint-disable-line
  return (
    <select value={value || ""} onChange={(e) => onChange(e.target.value)}
            className="px-3 py-2 rounded-lg text-sm w-full" data-testid={testid}>
      <option value="">Tous les comptes{accounts.length ? ` (${accounts.length})` : ""}</option>
      {accounts.map((a) => <option key={a.value} value={a.value}>{label(a)}</option>)}
    </select>
  );
};

const money = (v) => `${v > 0 ? "+" : ""}${Number(v || 0).toFixed(2)}$`;

/** Récapitulatif par compte (affiché quand le rapport couvre plusieurs comptes). */
export const AnalyticsAccountsTable = ({ accounts }) => {
  if (!accounts || accounts.length < 2) return null;
  return (
    <div className="mb-6" data-testid="analytics-by-account">
      <h3 className="text-sm font-bold text-cyan-300 mb-2">🏦 Répartition par compte</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="text-zinc-400 uppercase tracking-wider">
            <tr><th className="text-left py-1.5">Compte</th><th className="text-left">Broker / serveur</th>
              <th className="text-right">Trades</th><th className="text-right">Réussite</th>
              <th className="text-right">P. Factor</th><th className="text-right">Max DD</th><th className="text-right">P&L net</th></tr>
          </thead>
          <tbody className="font-mono">
            {accounts.map((a) => (
              <tr key={String(a.account_login)} className="border-t border-white/5"
                  data-testid={`analytics-account-row-${a.account_login ?? "unknown"}`}>
                <td className="py-1.5">{a.account_login ?? "Inconnu"}</td>
                <td className="font-sans">{a.account_server || a.broker || "—"}</td>
                <td className="text-right">{a.trades}</td>
                <td className="text-right">{a.winrate}%</td>
                <td className="text-right">{a.profit_factor == null ? "∞" : a.profit_factor}</td>
                <td className="text-right">{money(-a.max_dd)}</td>
                <td className={`text-right ${a.net_pnl < 0 ? "text-red-400" : "text-emerald-400"}`}>{money(a.net_pnl)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-[11px] text-zinc-500 mt-1">
        Choisissez un compte précis pour obtenir sa courbe Balance &amp; Drawdown dans le PDF.
      </div>
    </div>
  );
};
